export const getQueue = (state) => state.navigation.queue;

export const getLocation = (state) => state.navigation.location ?? {};
